import { useDispatch, useSelector } from "react-redux"
import { useState } from "react"
import { useEffect } from "react"
import { appointmentsActions } from "../../store/appointments"
import classes from './AppointmentsFilters.module.css'
import RangeDatePickerFilter from "../work_queues/pages/custom/filters/RangeDatePickerFilter"
import CustomSelect from "../common/interactive/CustomSelect"
import Button from "../common/Button"
import DatePickerWithLabelRanged from "../common/interactive/DatePickerWithLabelRanged"
import { appointmentDepartmentsOptions, nextgenAppointmentEventsOptions } from "../../lib/systemData"

export default function AppointmentsFilters() {
    const dispatch = useDispatch()
    const selectedFilters = useSelector(state => state.appointments.filters)

    const [filtersValues, setFiltersValues] = useState(null)

    function mainSelectAction(value) {
        let update = {
            ...filtersValues,
        }

        

        //need to expand the object and include name of the selected options!
        if (value?.data?.value?.constructor == Array) { // check if array
            update[value.identifier.type] = value.options
        } else {
            update[value.identifier.type] = {
                value: value.data.value,
                item: value.option
            }

            if (value.data.value == null) {
                delete update[value.identifier.type]
            }
        }   

        if (value.identifier.type == 'show_resolved') {
            if (value.data.value) {
                update.show_resolved = {
                    value: value.data.value,
                    item: value.option
                }
            } else {
                delete update.show_resolved
            }
        }

        setFiltersValues(update)

        // on change set filters....
        dispatch(appointmentsActions.setCurrentPage(1))
        dispatch(appointmentsActions.setFiltersMultiple(update))
    }

    function clearAllFiltersHandler() {
        dispatch(appointmentsActions.setFiltersMultiple({}))   
    }

    // set the filters from settings 
    useEffect(() => {
        let mergeTheSelectedFilters = {
            ...selectedFilters
        }
        setFiltersValues(mergeTheSelectedFilters)        
    }, [selectedFilters]) 

    const mockEventTypeOptions = [
        {
            label: 'Event Type 1',
            value: 'event_type_1'
        },
        {
            label: 'Event Type 2',
            value: 'event_type_2'
        }
    ]

    const mockDepartmentOptions = [
        {
            label: 'Department 1',
            value: 'department_1'
        },
        {
            label: 'Department 2',
            value: 'department_2'
        }
    ]

    return <div className={classes.master_filter}>

        {/* <RangeDatePickerFilter preSelectedValue={filtersValues?.date?.value} action={mainSelectAction} identifier={{type: 'date', label: 'Date'}} /> */}
        <DatePickerWithLabelRanged preSelectedValue={filtersValues?.date?.value} action={mainSelectAction} identifier={{type: 'date', label: 'Date'}} />
        <CustomSelect label={"Event Type"} optionsData={nextgenAppointmentEventsOptions()} preSelectedValue={filtersValues?.event_id?.value} action={mainSelectAction} name={'event_id'} identifier={{type: 'event_id', label: 'Event Type'}}/>

        <CustomSelect label={"Department"} optionsData={appointmentDepartmentsOptions()} preSelectedValue={filtersValues?.aica_dep_type?.value} action={mainSelectAction} name={'aica_dep_type'} identifier={{type: 'aica_dep_type', label: 'Department'}}/>

        <Button click={clearAllFiltersHandler} btnStyle={'btn_white'}>Clear</Button>  
    </div>
}